<!-- `subscriptSizing="dynamic"`: Ohne das reserviert Material unter dem Feld dauerhaft eine Zeile
     für Hinweis oder Fehler — dieses Suchfeld hat beides nie. Die tote Zeile machte das Feld nicht
     nur höher als benachbarte Buttons, sie verschob es auch optisch nach oben: `align-items: center`
     zentriert das GESAMTE Element samt leerer Reserve, der sichtbare Rahmen sitzt dadurch zu hoch. -->
<mat-form-field appearance="outline" subscriptSizing="dynamic">
  <input type="search" matInput placeholder="Suche" [(ngModel)]="text" />
  <mat-icon matSuffix>search</mat-icon>
</mat-form-field>
